import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EventButton, DeadlineDisplay, LoadingSpinner } from "../common";
import { NEWYEAR_ROUTES } from "../../../constants/newyearConstants";
import { getWinnerInfo } from "../../../store/api/newyearApi";

const DrawResultWin = ({ eventId }) => {
  const navigate = useNavigate();
  const [winnerInfo, setWinnerInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWinnerInfo = async () => {
      if (!eventId) return;

      try {
        const info = await getWinnerInfo(eventId);
        setWinnerInfo(info);
      } catch (err) {
        console.error("Failed to fetch winner info:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWinnerInfo();
  }, [eventId]);

  const handleGoToWinnerInfo = () => {
    navigate(`${NEWYEAR_ROUTES.WINNER_INFO}/${eventId}`);
  };

  if (loading) {
    return <LoadingSpinner message="당첨 정보를 불러오는 중..." />;
  }

  return (
    <div className="newyear-draw-result newyear-draw-result--win">
      <div className="newyear-draw-result__icon">
        <span className="newyear-draw-result__emoji">
          &#127881;
        </span>
      </div>

      <h2 className="newyear-draw-result__title">축하합니다!</h2>
      <p className="newyear-draw-result__message">
        추첨에 당첨되셨습니다!
      </p>

      {winnerInfo?.deadline && (
        <DeadlineDisplay
          deadline={winnerInfo.deadline}
          label="당첨자 정보 제출 마감"
        />
      )}

      <div className="newyear-draw-result__notice">
        <p>경품 수령을 위해 당첨자 정보를 입력해주세요.</p>
        <p className="newyear-draw-result__warning">
          기한 내 미입력 시 당첨이 취소됩니다.
        </p>
      </div>

      <div className="newyear-draw-result__actions">
        <EventButton
          variant="success"
          size="large"
          fullWidth
          onClick={handleGoToWinnerInfo}
        >
          당첨자 정보 입력하기
        </EventButton>
      </div>
    </div>
  );
};

export default DrawResultWin;
